module.exports = __webpack_public_path__ + "static/homo-deus-94e05ddf8f3e810cd285aae5344686c3.webp";